import React from 'react';
import { Table, Message, Menu, Icon, Dimmer, Loader, Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import Moment from 'moment';

const SysadminClientListTable = (props) => {
    const paginationInfo = `${(props.perPage*props.currentPage)-props.perPage+1}-${(props.perPage*props.currentPage)>props.totalData ? props.totalData : (props.perPage*props.currentPage)} of ${props.totalData}`
    return (
        <Dimmer.Dimmable>
            <Dimmer active={props.isLoading} inverted>
                <Loader/>
            </Dimmer>
            <Table celled selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>ID</Table.HeaderCell>
                        <Table.HeaderCell>NRIC</Table.HeaderCell>
                        <Table.HeaderCell>Student ID</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Company Name</Table.HeaderCell>
                        <Table.HeaderCell>Start Date</Table.HeaderCell>
                        <Table.HeaderCell>Termination Date</Table.HeaderCell>
                        <Table.HeaderCell>Member Type</Table.HeaderCell>
                        <Table.HeaderCell>No. of Dep</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        props.users.length === 0 ?
                        <Table.Row>
                            <Table.Cell colSpan={9} textAlign="center">
                                <Message info>
                                    No user data.
                                </Message>
                            </Table.Cell>
                        </Table.Row>
                        :
                        _.map(props.users, (user) => {
                            const {
                                uuid,
                                nric,
                                studentID,
                                name,
                                companyName,
                                companyId,
                                effectiveStartDate,
                                effectiveEndDate,
                                memberType,
                                family,
                            } = user;
                            return (
                                <Table.Row key={uuid}>
                                    <Table.Cell>
                                        <Link to={`/systemadmin/user/update?idUser=${uuid}`}>{uuid}</Link>
                                    </Table.Cell>
                                    <Table.Cell>{nric.toUpperCase()}</Table.Cell>
                                    <Table.Cell>{studentID || '-'}</Table.Cell>
                                    <Table.Cell>{name}</Table.Cell>
                                    <Table.Cell>{companyName}</Table.Cell>
                                    <Table.Cell>{effectiveStartDate ? Moment(effectiveStartDate).format('DD/MM/YYYY') : '-'}
                                    </Table.Cell>
                                    <Table.Cell>{effectiveEndDate ? Moment(effectiveEndDate).format('DD/MM/YYYY') : '-'}
                                    </Table.Cell>
                                    <Table.Cell>{ memberType === 'e' ? 'Employee' : 'Dependent' }</Table.Cell>
                                    <Table.Cell>{ memberType === 'e' ? family.length : '-'}</Table.Cell>
                                </Table.Row>
                            );
                        })
                    }
                </Table.Body>
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell colSpan='9'>
                            <Menu floated='right' pagination>
                                <Menu.Item as='a' icon onClick={props.goToPreviousPage}
                                    disabled={props.currentPage === 1}>
                                    <Icon name='chevron left'/>
                                </Menu.Item>
                                <Menu.Item>{paginationInfo}</Menu.Item>
                                <Menu.Item as='a' icon onClick={props.goToNextPage}
                                    disabled={props.users.length < props.perPage}>
                                    <Icon name='chevron right'/>
                                </Menu.Item>
                            </Menu>
                            <Menu floated='right' pagination>
                                <Menu.Item>Page</Menu.Item>
                                <Dropdown scrolling item text={props.currentPage.toString()} defaultValue={props.currentPage}>
                                    <Dropdown.Menu>
                                        {[...Array(props.totalPage)].map((e, i) =>
                                            <Dropdown.Item key={i} onClick={() => props.setPage(i+1)}>{i+1}</Dropdown.Item>
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Menu>
                            <Menu floated='right' pagination>
                                <Menu.Item>View</Menu.Item>
                                <Dropdown item text={props.perPage.toString()} defaultValue={props.perPage}>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => props.setPerPage(10)}>10</Dropdown.Item>
                                        <Dropdown.Item onClick={() => props.setPerPage(20)}>20</Dropdown.Item>
                                        <Dropdown.Item onClick={() => props.setPerPage(50)}>50</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Menu>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        </Dimmer.Dimmable>
    );
}

export default SysadminClientListTable;